'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import '@dynamic-labs/sdk-api-core';
import { logger } from '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '@dynamic-labs/utils';
import '../../../utils/constants/colors.js';
import '../../../utils/constants/values.js';
import '../../../shared/consts/index.js';
import { sdkApi } from '../api.js';
import { isDynamicContextSessionSettingExpired, setDynamicContextSessionSettings, isWagmiSessionSettingExpired, setWagmiSessionSettings } from '../../../context/DynamicContext/helpers/helpers.js';
import { VERSION } from '../../../../version.js';

const fetchProjectSettings = (environmentId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield sdkApi().getEnvironmentSettings({
            environmentId,
            sdkVersion: `WalletKit/${VERSION}`,
        }, {
            credentials: 'omit',
        });
        return res;
    }
    catch (e) {
        logger.error(e);
        return undefined;
    }
});
/**
 * Detects circular references in an object, and replaces them with a string
 * This ensures we can JSON stringify the object without errors
 *
 * @param obj
 * @returns obj mutated object with circular references replaced
 */
const detectCircular = (obj) => {
    const seen = new WeakMap();
    const _recursive = (obj, parentKey = '') => {
        for (const key in obj) {
            const thisKey = parentKey + (parentKey === '' ? '' : '.') + key;
            if (typeof obj[key] === 'object') {
                if (seen.has(obj[key])) {
                    const seenKey = seen.get(obj[key]);
                    obj[key] = `[Circular Reference => ${seenKey}]`;
                    continue;
                }
                seen.set(obj[key], thisKey);
                _recursive(obj[key], thisKey);
            }
        }
        return obj;
    };
    return _recursive(obj);
};
const sendDynamicProps = (environmentId, settingsToSend) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { dynamicContextProps, dynamicWagmiSettings, frameworkSettings } = settingsToSend;
        if (dynamicContextProps) {
            yield sendDynamicContextSettings(environmentId, { dynamicContextProps, frameworkSettings }, isDynamicContextSessionSettingExpired, setDynamicContextSessionSettings);
        }
        if (dynamicWagmiSettings) {
            yield sendDynamicContextSettings(environmentId, { dynamicWagmiSettings }, isWagmiSessionSettingExpired, setWagmiSessionSettings);
        }
    }
    catch (error) {
        logger.warn('Error caught when sending sdkSettings to api. Please notify Dynamic, and send the DynamicContextProvider settings you currently have configured', { error });
    }
});
const sendDynamicContextSettings = (environmentId, sdkSettingsRequest, isSdkSettingExpired, setSDKSessionSettings) => __awaiter(void 0, void 0, void 0, function* () {
    // sent once. no need to send again
    if (!isSdkSettingExpired()) {
        return;
    }
    yield sdkApi().logDynamicSdkSettings({
        environmentId,
        sdkSettingsRequest: detectCircular(sdkSettingsRequest),
    });
    setSDKSessionSettings();
});

export { fetchProjectSettings, sendDynamicProps };
